import { Spin } from 'antd';
import { StyledDrawer } from './Drawer.styled';

const Drawer = ({ loading = false, children, ...props }) => {
  return (
    <StyledDrawer
      destroyOnClose={true}
      visible={true}
      placement="right"
      maskClosable={false}
      keyboard={true}
      {...props}
    >
      <Spin wrapperClassName="drawer-spinner" spinning={loading}>
        <div className="main-content">{children}</div>
      </Spin>
    </StyledDrawer>
  );
};

export default Drawer;
